import { Accomodation } from "@models/accomodation.model";
import { BaseConverter } from "@converter/BaseConverter";
import { AccomodationDto } from "@dtos/accomodation.dto"; 
import { hostConverter } from "@converter/hostConverter";


export class AccomodationConverter extends BaseConverter<Accomodation, AccomodationDto>{
    private hostConverter = new hostConverter()
    modelToDto(model: Accomodation): AccomodationDto {
        return new AccomodationDto(
            model.id,
            model.name,
            model.fullAddress,
            model.latitude,
            model.longitude,
            model.qrCodeImg,
            model.active,
            model.creationDate?.toISOString(),
            model.updateDate?.toISOString(),
            model.logo,
            model.imgMobile,
            model.imgDesktop,
            model.qrCodeId,
            model.lastVisitDate?.toISOString(),
            model.host? this.hostConverter.modelToDto(model.host): undefined
        )
    }


    dtoToModel(dto: AccomodationDto): Accomodation {
        return new Accomodation(
            dto.id,
            dto.name,
            dto.fullAddress,
            dto.latitude,
            dto.longitude,
            dto.qrCodeImg,
            dto.active,
            dto.creationDate? new Date(dto.creationDate) : undefined,
            dto.updateDate? new Date(dto.updateDate) : undefined,
            dto.logo,
            dto.imgMobile,
            dto.imgDesktop,
            dto.qrCodeId,
            dto.lastVisitDate? new Date(dto.lastVisitDate) : undefined,
            dto.host ? this.hostConverter.dtoToModel(dto.host) : undefined
        )
        
    }
}